import React from 'react'
import { Space } from '../../layouts'
import { H3 } from '../StyledText'

export const DetailsPanelContent = ({ titleName, children }) => (
  <Space mb={4}>
    <H3 mb={2}>{titleName}</H3>
    {children}
  </Space>
)
